import {FC, SVGProps, useId} from 'react';

export const IconLogoTitle: FC<SVGProps<SVGSVGElement>> = ({
    width = 229,
    height = 52,
    ...props
}) => {
    const clipId = useId();

    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 229 52"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <title>wehorse</title>
            <g clipPath={`url(#${clipId})`}>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M43.3857 19.27C49.4907 19.27 52.5615 23.158 52.5615 27.978V28.6401L40.7461 35.4526C41.8586 36.0663 43.7349 36.3527 45.0625 36.2749C47.4995 36.1335 49.8339 34.8851 51.6562 34.0708L52.1006 38.4526C49.369 39.5453 47.0553 40.0601 43.9004 40.0601C35.7872 40.0599 32.6904 34.6864 32.6904 29.7671C32.6906 23.3523 37.5881 19.2702 43.3857 19.27ZM43.2949 22.9487C39.3253 22.9174 35.6576 27.2215 37.9688 32.7104L48.334 26.729C48.3337 24.2802 45.9757 22.9699 43.2949 22.9487Z"
                    fill="var(--color-icon-logo-text)"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M145.926 19.27C152.031 19.27 155.102 23.158 155.102 27.978V28.6401L143.285 35.4526C144.398 36.0665 146.275 36.3528 147.603 36.2749C150.039 36.1335 152.374 34.8851 154.196 34.0708L154.641 38.4526C151.908 39.5452 149.595 40.0601 146.44 40.0601C138.327 40.06 135.23 34.6865 135.23 29.7671C135.231 23.3522 140.128 19.2701 145.926 19.27ZM145.834 22.9487C141.865 22.9177 138.198 27.2217 140.509 32.7104L150.874 26.729C150.874 24.2801 148.515 22.9698 145.834 22.9487Z"
                    fill="var(--color-icon-logo-text)"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M88.5234 19.27C94.3162 19.27 99.292 22.8078 99.292 29.729C99.292 35.9503 94.4695 39.9165 88.4453 39.9165C82.3426 39.9164 77.6758 35.8317 77.6758 29.729C77.6758 23.002 82.8466 19.27 88.5234 19.27ZM88.4824 23.0425C84.7914 23.0427 82.2638 25.6073 82.2637 29.729C82.2637 33.6948 84.7913 36.1439 88.4824 36.144C92.098 36.144 94.7422 33.771 94.7422 29.729C94.7421 25.3753 92.098 23.0425 88.4824 23.0425Z"
                    fill="var(--color-icon-logo-text)"
                />
                <path
                    d="M125.33 19.271C127.663 19.271 129.763 19.5049 132.212 20.0874L131.667 23.8188C129.802 23.2744 127.235 23.0025 125.059 23.0024C122.92 23.0024 121.443 23.5464 121.442 25.063C121.442 28.3282 133.338 26.5801 133.338 34.0054C133.338 37.6992 129.724 39.9165 124.126 39.9165C121.442 39.9165 119.381 39.604 117.126 38.9038L117.632 35.2505C119.693 35.8728 122.181 36.1831 124.592 36.1831C126.729 36.1831 128.83 35.7543 128.83 34.0435C128.829 30.236 116.894 31.9443 116.894 25.2573C116.894 21.2154 120.86 19.271 125.33 19.271Z"
                    fill="var(--color-icon-logo-text)"
                />
                <path
                    d="M7.9707 35.7437H8.24219L12.6348 19.8423H18.7783L23.5215 35.7437H23.793L26.8252 19.8423H31.2959L26.9434 39.5161H20.1768L15.7451 23.9263H15.5127L11.4688 39.5161H4.74316L0 19.8423H4.70312L7.9707 35.7437Z"
                    fill="var(--color-icon-logo-text)"
                />
                <path
                    d="M60 22.0991C61.943 20.4264 64.5863 19.3375 67.3848 19.3374C70.4965 19.3374 74.8119 20.3104 74.8115 26.1431V39.5151H70.4961V27.5415C70.4961 24.2357 68.8248 23.2251 66.0254 23.2251C64.1192 23.2251 61.7881 23.9264 60 25.5591V39.5151H55.6836V11.4116H60.0068L60 22.0991Z"
                    fill="var(--color-icon-logo-text)"
                />
                <path
                    d="M113.898 19.4165C114.25 19.4165 114.56 19.4156 114.988 19.4536V23.8853C114.326 23.8092 113.549 23.77 112.849 23.77C110.516 23.7701 108.185 25.0143 106.513 26.6069V39.5151H102.196V19.8442H106.513V23.1099C108.457 21.2052 111.101 19.4161 113.898 19.4165Z"
                    fill="var(--color-icon-logo-text)"
                />
                <path
                    d="M188.159 0.0255055C189.406 -0.106084 190.594 0.2886 191.74 0.8161C192.895 1.3478 194.299 2.15949 196.017 3.15022L221.216 17.6755C222.939 18.6684 224.347 19.4783 225.388 20.2125C226.42 20.9408 227.359 21.7721 227.869 22.9186C228.606 24.5708 228.606 26.4578 227.869 28.11C227.359 29.2564 226.42 30.0878 225.388 30.8161C224.347 31.5503 222.939 32.3602 221.216 33.353L212.913 38.1392L210.921 34.836L219.29 30.0119C221.078 28.9811 222.303 28.273 223.165 27.665C224.035 27.0513 224.269 26.7155 224.347 26.5404C224.638 25.8873 224.638 25.1413 224.347 24.4882C224.269 24.3131 224.035 23.9774 223.165 23.3635C222.303 22.7555 221.078 22.0475 219.29 21.0167L194.091 6.49135C192.307 5.46265 191.083 4.75931 190.127 4.31917C189.162 3.87502 188.755 3.84047 188.564 3.86057C187.854 3.93562 187.208 4.30871 186.789 4.88669C186.676 5.04197 186.503 5.41186 186.406 6.46933C186.31 7.51749 186.307 8.92904 186.307 10.989V12.3862L182.454 9.35099C182.46 8.09252 182.483 7.01529 182.565 6.11705C182.68 4.86085 182.932 3.63465 183.668 2.62036C184.73 1.15834 186.362 0.215296 188.159 0.0255055Z"
                    fill="var(--raw-primary-brand)"
                />
                <path
                    d="M189.981 51.4714L209.447 40.1985L191.647 13.4997L187.791 18.5428L182.451 14.093V21.2127L169.102 41.7601L172.312 46.8595L189.133 38.7126L189.981 51.4714Z"
                    fill="var(--raw-primary-brand)"
                />
            </g>
            <defs>
                <clipPath id={clipId}>
                    <rect width={228.422} height={51.4714} fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
